<template>
  <div class="container-fluid mt-4">
    <div class="row mb-4">
      <div class="col-lg-12">
        <invoice-card />
      </div>
    </div>
    
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import InvoiceCard from "./components/InvoiceCard.vue";
import HTFetch from "../llamadas/HTFetch"

export default {
  name: "Billing",

  data() {
    return {
      llamada: new HTFetch(),
    };
  },

  components: {
    InvoiceCard,
    
  },
  mounted() {
    setTooltip();
    this.bringData()
  },

  methods: {
    bringData() {
      this.llamada.getStripeData(this.bringDataRsp.bind(this))
    },

    bringDataRsp(rsp) {
      console.log(rsp)
    }
  }
};
</script>
